import { ContactFormData, ContactFormResponse } from '../types/contact';

// API endpoint - will need to be updated with actual Lambda URL
const CONTACT_API_ENDPOINT = import.meta.env.VITE_CONTACT_API_URL || '';

/**
 * Sends a contact form submission via AWS Lambda function that uses SES.
 */
export const sendContactForm = async (data: ContactFormData): Promise<ContactFormResponse> => {
  if (!CONTACT_API_ENDPOINT) {
    throw new Error('Contact API endpoint not configured');
  }

  const response = await fetch(CONTACT_API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Failed to send message (${response.status})`);
  }

  return response.json();
};
